module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "regular-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit()
      }
    }
  }, [_c('otp-field', {
    attrs: {
      "error": _vm.$attrs.errors.user.otp
    },
    model: {
      value: (_vm.$attrs.user.otp),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.user, "otp", $$v)
      },
      expression: "$attrs.user.otp"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.submitLabel
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68c36fff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/privat_otp_auth/PrivatOtpAuthBlankForm.vue
// module id = 666
// module chunks = 0